module.exports = __webpack_public_path__ + "img/1F5EF.ebfb18ef.svg";